import React, { Component } from 'react';
import { request } from 'http';


const Data = [
	{
		ctg:"Backup & storage",
		items: [
			{
				icon:require('./img/driveIcon.png'),
				k:"backUpGoogleDrive",
				b:"Back up to Google Drive",
				t:"Easily restore or switch phones at any time. Backup includes apps and app data, calendar, call history, contacts, device settings, wi-fi passwords, photos and videos, and SMS."
			}, 
			{
				icon:require('./img/storageIcon.svg'),
				k:"gs2_freeSpace",
				b:"Free up space",
				t:"When your device storage is almost full, free space by removing some data, like backed up photos and videos."
			}, 
		]
	},
	{
		ctg:"location",
		items: [
			{
				icon:require('./img/locationIcon.svg'),
				k:"gs0_googleLocation",
				b:"Help apps find location",
				t:"Use Google's location services to help apps determine your location. Anonymous location data will be sent to Google When your device is on."
			}, 
			{
				icon:require('./img/locationIcon.svg'),
				k:"gs1_improveLocation",
				b:"Improve location accuracy",
				t:"Allow apps and services to scan for Wi-Fi and Bluetooth, even when these settings are off."
			}, 			
		]
	},
	{
		ctg:"Device maintenance",
		items: [
			{
				icon:require('./img/dataIcon.svg'),
				k:"gs3_improveAndroidExperience",
				b:"Send system data",
				t:"Help improve your Android experience by automatically sending diagnostic and device and app usage data to Google. This won't be used to identify you and will help improve battery life, app stabillty, network connectivity, and more."
			}, 
			{
				icon:require('./img/getAppIcon.svg'),
				b:"Install updates & apps",
				t:"By continuing, you agree that this device may also automatically download and install updates and apps from Google, your carrier, and your device's manufacturer, possibly using cellular data. Some of these apps may offer in-app purchases. You can remove these apps at any time.",
				noBtn:true,
				noSeparationLine:true,
			}, 
		]
	}
	
]
class Row extends Component {
	state = {on: true}
	componentDidMount() {
		this.updateValue()
		this.updateValue = this.updateValue.bind(this)
	}
	updateValue() {
		const {k} = this.props.data
		k && global.setAnswer(k, this.state.on)
	}
	render() {
		const {data} = this.props
		return <div>
			<div style={{
				marginTop: 15,
				display:"flex",
			}}>
				<img src={data.icon} style={{
					width:20,
					height:20,
					marginLeft:0,
					marginTop:0,
					opacity:1
				}} />
				<div style={{
					width: data.noBtn ? 276 : 236,
					marginLeft:16,
					// backgroundColor:"red"
				}}>
					<span style={{
						// fontWeight:"bold",
						fontSize: 16,
					}}>{data.b}</span>
					<br/>
					<span style={{
						fontSize:13,		
						color: '#8f8f8f',		
						// fontWeight:"bold",
					}}> {data.t}</span>
				</div>
				{!data.noBtn && <img src={this.state.on ? require('./img/rOn.png'): require('./img/rOff.png')} 
					onClick={() => this.setState({on:!this.state.on}, this.updateValue)}
					style={{
						cursor:"pointer",
						width:45,
						height:45,
						alignSelf:"center"	

					}}
				/>}
			</div>
			{!data.noSeparationLine && <div style={{
				marginLeft: 0,
				width:310,
				height:1,
				backgroundColor:"black",
				opacity:0.2,
				marginTop:15
			}} />}
		</div>
	}
}
	

export default class GoogleServices extends Component {
	render() {
		const {t,l} = this.props
		return <div style={{
			position:"absolute",
			left: 0,
			top: 0,
			width:360,
			height: global.isMobile ? 1480 : 1380,
			fontSize: 16,
		}}>
	
			<img src={require('./img/logo.jpg')} style={{
				position:"absolute",
				left: 24,
				top: 32,
				width:32,
				height:32
			}} />
			<div style={{
				position:"absolute",
				left: 24,
				top: 96,
				width:360 - 48,
				height:100,
			}}>
				<span style={{
					fontWeight:"bold"	
				}}>Google services</span>
				<br/>
				<br/>
				<span style={{	
					
				}}>example@gmail.com</span>
				<br/>
				<br/>
				<span style={{	
					
				}}>Tap to learn more about each service, such as how to turn it on or off later. Data will be used according to Google's <span style={{
					color:global.blue	
				}}>Privacy Policy</span>. </span>
				<br/>
				<br/>				
			</div>
			<div style={{
				position:"absolute",
				left:24,
				top:270,
			}}>
				{Data.map((_,i) => {
					const itemsHtml = _.items.map((_,j) => <Row data={_} key={j}/>)
					return <div style={{marginBottom: 32}}>
						<span> {_.ctg} </span>
						<div style={{
							marginLeft: 0,
							width:310,
							height:1,
							backgroundColor:"black",
							opacity:0.2,
							marginTop:15
						}} />
						{itemsHtml}						
					</div>
				})}
			</div>			
			
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/GoogleServices.js